import * as ActionType from "./language.type";

const initialState = {
  languages: [],
  dialog: false,
  dialogData: null,
};

export const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_LANGUAGE:
      return {
        ...state,
        languages: action.payload,
      };
    case ActionType.OPEN_LANGUAGE_DIALOG:
      return {
        ...state,
        dialog: true,
        dialogData: action.payload || null,
      };
    case ActionType.CLOSE_LANGUAGE_DIALOG:
      return {
        ...state,
        dialog: false,
        dialogData: null,
      };
    case ActionType.CREATE_LANGUAGE:
      return {
        ...state,
        languages: [action.payload, ...state.languages],
      };
    case ActionType.UPDATE_LANGUAGE:
      return {
        ...state,
        languages: state.languages.map((lang) =>
          lang._id === action.payload.id ? action.payload.data : lang
        ),
      };
    case ActionType.DELETE_LANGUAGE:
      return {
        ...state,
        languages: state.languages.filter((lang) => lang._id !== action.payload),
      };
    default:
      return state;
  }
};
